export const DEFAULT_FAN_NUMBER = 2
